export default __webpack_public_path__ + "static/media/error400.d3a8a49b.svg";